export enum AdjustPaymentAnalyticsMessages {
  capability = 'payments',
  pageLoadedEvent = 'page loaded',
  modalOpenEvent = 'modal open',
  modalCloseEvent = 'modal close',
  modalSubmittedEvent = 'short pay submitted',
  shortPayModalName = 'short pay',
  pageName = 'us foods:r4:adjust payment',
}
